<template>
  <div class="backstage_tab">
    <!-- BackstageTab1 -->
    <SearchQuery
      :isSelect="false"
      @letterVal="letterVal"
      @addNew="addNew"
      @searchData="searchData"
      :isChange="isChange"
      :active="active"
    ></SearchQuery>

    <!-- 数据表格 -->
    <div class="table">
      <TableTem
        size="mini"
        :isSelection="false"
        :isIndex="true"
        :isPagination="true"
        :isHandle="true"
        :tableData="tableData"
        :tableCols="tableCols"
        :pagination="pagination"
        @select="select"
        @switchVal="switchVal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        @passRowData="passRowData"
      ></TableTem>
    </div>
    <!-- 添加企业信息列表 -->
    <DataDialog
      @visible="visible"
      :passVisible="dataVisible"
      :title="dataTitle"
      :editCompany="editCompany"
      @submitForm="submitForm"
      :isAdd="isAdd"
    ></DataDialog>
  </div>
</template>

<script>
//搜索
import SearchQuery from "./SearchQuery.vue";
//企业信息
import DataDialog from "./DataDialog.vue";
import { alphabeticQuery, CompanyTable } from "@/conf/Backstage.js";
//封装的表格
import TableTem from "./TableTem.vue";
import {
  companyDetail,
  updateState,
  companyDetailNews,
  infoUpdate,
  addComapny,
  delCompanyInfo
} from "@/common/js/http/version3Api.js";

export default {
  name: "CompanyTable",
  components: {
    TableTem,
    SearchQuery,
    DataDialog
  },
  data() {
    return {
      dataVisible: false,
      companyId: "",
      isAdd: false,
      dataTitle: "",
      active: "",
      alphabeticQuery,
      tableCols: CompanyTable,
      name: "",
      id: "",
      findCompanyId: "",
      status: "1",
      tableData: [],
      isChange: -1,
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 7
      },
      editCompany: [],
      params: null,
      letter: ""
    };
  },
  created() {
    this.getComapnyData();
  },
  mounted() {
    //this.loading = true
  },
  methods: {
    //点击submitForm
    submitForm(formData) {
      if (this.isAdd) {
        addComapny(formData).then(res => {
          this.getComapnyData();
        });
      } else {
        infoUpdate(formData).then(res => {
          if (res.code === 200) {
            this.getComapnyData();
          } else {
            return;
          }
        });
      }
    },
    // 获取 表格传递的数据
    async passRowData(rowData) {
      if (rowData.button === "edit") {
        this.isAdd = false;
        this.companyId = rowData.rowData.id;
        companyDetailNews({ id: this.companyId }).then(res => {
          this.editCompany = res.result.list;
        });
      } else {
        delCompanyInfo(rowData.rowData.id).then(res => {
          if (res.code === 200) {
            this.$message({
              message: res.message,
              type: "success"
            });
            this.getComapnyData();
          }
        });
      }

      let buttonType = rowData.button;
      switch (buttonType) {
        case "edit":
          // 添加关联品牌
          this.dataVisible = true;
          this.dataTitle = "Edit Brand";

          break;
      }
    },
    select(row) {},
    visible(val) {
      this.dataVisible = val;
    },
    letterVal(searchQuery, index) {
      this.letter = searchQuery.letterVal;
      if (index != this.isChange) {
        this.isChange = index;
        this.active = searchQuery.letterVal;
        this.getComapnyData();
      } else {
        this.isChange = -1;
        this.active = "";
        //this.keyWords = "";
        this.letter = "";
        this.getComapnyData();
      }
    },
    searchData(searchString) {
      this.name = searchString.inpVal;
      if (searchString.inpVal === "") {
        this.getComapnyData();
      } else {
        this.getComapnyData();
      }
    },
    switchVal(switchList) {
      this.id = switchList.id;
      this.status = switchList.status;
      this.updateCompanyStatus();
    },
    addNew() {
      this.companyId = "";
      this.editCompany = [];
      this.dataVisible = true;
      this.isAdd = true;
      this.dataTitle = "Add Company";
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getComapnyData();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
    },
    //获取企业列表
    getComapnyData() {
      let data = {
        letter: this.letter,
        name: this.name,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize
      };
      companyDetail(data).then(res => {
        this.tableData = res.result.list;
        this.pagination.pageSize = res.result.pageSize;
        this.pagination.pageNum = res.result.pageNum;
        this.pagination.total = res.result.total;
      });
    },
    //更新企业状态
    updateCompanyStatus() {
      let data = {
        id: this.id,
        status: this.status
      };
      updateState(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.backstage_tab {
  /* min-height: 300px; */
  margin: 20px 0;
}

.page {
  text-align: center !important;
  padding: 20px;
}
</style>